import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import './i18n'; // Импортируем конфигурацию i18next
import ReactGA from 'react-ga4';
import WebApp from '@twa-dev/sdk';
import TelegramAnalytics from '@telegram-apps/analytics';

WebApp.ready();
WebApp.expand();

const GA4_ID = process.env.REACT_APP_GA4_ID;
if (GA4_ID) {
  ReactGA.initialize(GA4_ID);
}

if (process.env.REACT_APP_TG_ANALYTICS_TOKEN && process.env.REACT_APP_ENV !== 'local') {
  TelegramAnalytics.init({
    token: process.env.REACT_APP_TG_ANALYTICS_TOKEN,
    appName: 'skinforge_bot',
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <BrowserRouter>
    <App />
  </BrowserRouter>
  // </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
